'use client';

import { createClient as createSupabaseClient } from '@supabase/supabase-js';

const PFX = 'sb-';
// 30 days in seconds
const REMEMBER_MAX_AGE = 60 * 60 * 24 * 30;

const getRememberMe = (): boolean => {
  try {
    const val = localStorage.getItem('sb_remember_me');
    // Default true — existing sessions stay alive
    return val === null ? true : val === '1';
  } catch {
    return true;
  }
};

// Custom localStorage-based storage adapter
const localStorageAdapter = {
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch {}
  },
};

let _client: ReturnType<typeof createSupabaseClient> | null = null;

export function createClient() {
  if (_client) return _client;

  _client = createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        // Persist session in localStorage — survives PWA restarts
        persistSession: true,
        storageKey: `${PFX}auth`,
        storage: localStorageAdapter,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    }
  );

  return _client;
}
